var map = {
	"./av.png": 301,
	"./karmicna_natalna_karta.jpeg": 63,
	"./karmicna_sinastrija.jpeg": 548,
	"./letni horoskop.jpeg": 290,
	"./natalna_karta.jpeg": 386,
	"./profile.jpeg": 914,
	"./profile.png": 653,
	"./sinastrija.jpeg": 755,
	"./vortex-contact-1536x878.webp": 486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;